export const pathInfo = {
  home: '/home',
  position: '/position',
  social: '/social',
  campus: '/campus',
  competition: '/competition',
  sharePosition: '/share-position',
  questionSocial: '/question/social',
  questionCampus: '/question/campus',
  questionAnnouncement: '/question/announcement',
  beidou: '/beidou',
  qihang: '/qihang',
  trainee: '/trainee',
  longcat: '/longcat',
  beidouprogram: '/beidouprogram',
  workInMeituan: '/about/workInMeituan',
  ourTeam: '/about/ourTeam',
};
